(function() {
  // Wait for DOM to be ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initKimonixQuickView);
  } else {
    initKimonixQuickView();
  }

  function initKimonixQuickView() {
    // Function to inject quickbuy-toggle button with product-block structure
    function setupKimonixQuickView(kmnxCard) {
      // Check if already set up
      const existingBtn = kmnxCard.querySelector('.kmnx-quickbuy-toggle');
      if (existingBtn && existingBtn.closest('.product-block')) {
        return existingBtn;
      }

      // Find the product link first
      const kmnxProductLink = kmnxCard.id === 'kmnx-open-prd' ? kmnxCard : kmnxCard.querySelector('a[id="kmnx-open-prd"]');
      if (!kmnxProductLink || kmnxProductLink.id !== 'kmnx-open-prd') {
        return null;
      }

      // Check if this product has more than 1 variant (data-kmnx-variants-number > 1)
      // Search more broadly for the attribute - it can be on .kmnx-add-btn or any element in the card
      let variantsNumber = null;
      
      // Method 1: Search within the product link element
      const kmnxAddBtnInLink = kmnxProductLink.querySelector('.kmnx-add-btn');
      if (kmnxAddBtnInLink) {
        variantsNumber = kmnxAddBtnInLink.getAttribute('data-kmnx-variants-number');
      }
      
      // Method 2: If not found, search in parent container (the card wrapper)
      if (!variantsNumber) {
        const parentContainer = kmnxProductLink.parentElement;
        if (parentContainer) {
          const allAddBtns = parentContainer.querySelectorAll('.kmnx-add-btn');
          for (const btn of allAddBtns) {
            const vNum = btn.getAttribute('data-kmnx-variants-number');
            if (vNum) {
              variantsNumber = vNum;
              break;
            }
          }
        }
      }
      
      // Method 3: Search in the entire card structure (closest div wrapper)
      if (!variantsNumber) {
        const cardWrapper = kmnxProductLink.closest('div[style*="scroll-snap"]') || 
                           kmnxProductLink.closest('div')?.parentElement;
        if (cardWrapper) {
          const allAddBtns = cardWrapper.querySelectorAll('.kmnx-add-btn');
          for (const btn of allAddBtns) {
            const vNum = btn.getAttribute('data-kmnx-variants-number');
            if (vNum) {
              variantsNumber = vNum;
              break;
            }
          }
        }
      }
      
      // Method 4: Search for any element with the attribute in the card
      if (!variantsNumber) {
        const cardElement = kmnxProductLink.closest('div');
        if (cardElement) {
          const elementWithAttr = cardElement.querySelector('[data-kmnx-variants-number]');
          if (elementWithAttr) {
            variantsNumber = elementWithAttr.getAttribute('data-kmnx-variants-number');
          }
        }
      }

      // Only inject for products with more than 1 variant
      const variantsNum = parseInt(variantsNumber, 10);
      if (!variantsNumber || isNaN(variantsNum) || variantsNum <= 1) {
        return null;
      }

      const productUrl = kmnxProductLink.getAttribute('href');
      if (!productUrl) {
        return null;
      }

      // Remove query parameters from URL for quick view
      const cleanProductUrl = productUrl.split('?')[0];
      
      // Extract product handle for data attribute
      const productHandleMatch = cleanProductUrl.match(/\/products\/([^/]+)/);
      const productHandle = productHandleMatch ? productHandleMatch[1] : '';

      // Find where to insert the button (look for .kmnx-desc or similar container)
      const kmnxDesc = kmnxProductLink.querySelector('.kmnx-desc') || kmnxProductLink;
      
      // Create a minimal product-block wrapper
      const productBlock = document.createElement('product-block');
      productBlock.className = 'product-block kmnx-quickview-wrapper';
      productBlock.style.display = 'contents'; // Don't affect layout
      if (productHandle) {
        productBlock.setAttribute('data-product-handle', productHandle);
      }

      // Create quickbuy-container (required by theme)
      const quickbuyContainer = document.createElement('div');
      quickbuyContainer.className = 'quickbuy-container use-color-scheme use-color-scheme--' + (window.theme?.settings?.quickbuy_color_scheme || 'default');
      quickbuyContainer.innerHTML = `
        <a href="#" class="close-detail" aria-label="Close" tabindex="-1">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1">
            <path d="M18 6L6 18M6 6l12 12"></path>
          </svg>
        </a>
        <div class="ovly"></div>
        <div class="inner"></div>
      `;

      // Create the quickbuy-toggle button (visible)
      const quickbuyBtn = document.createElement('a');
      quickbuyBtn.className = 'btn btn--large quickbuy-toggle kmnx-quickbuy-toggle';
      quickbuyBtn.href = cleanProductUrl;
      quickbuyBtn.setAttribute('rel', 'nofollow');
      
      // Add the SVG icon (same as theme's quickbuy button)
      quickbuyBtn.innerHTML = `
        <svg class="icon" width="24" height="24" viewBox="0 0 24 24" aria-hidden="true" focusable="false" role="presentation">
          <g fill="none" fill-rule="evenodd">
            <path d="M0 0h24v24H0z"></path>
            <path d="M15.321 9.5V5.321a3.321 3.321 0 0 0-6.642 0V9.5" stroke="currentColor" stroke-width="1.5"></path>
            <path stroke="currentColor" stroke-width="1.5" d="M5.357 7.705h13.286l1.107 13.563H4.25z"></path>
          </g>
        </svg>
      `;

      // Append button and container to product-block
      productBlock.appendChild(quickbuyBtn);
      productBlock.appendChild(quickbuyContainer);

      // Insert the product-block into the Kimonix card structure
      kmnxDesc.appendChild(productBlock);

      return quickbuyBtn;
    }

    // Function to process all Kimonix cards on the page
    function processKimonixCards() {
      const kmnxCards = document.querySelectorAll('a[id="kmnx-open-prd"]:not(.kmnx-processed)');
      
      kmnxCards.forEach(card => {
        // Mark as processed to avoid re-processing
        card.classList.add('kmnx-processed');
        setupKimonixQuickView(card);
      });
    }

    // Process existing cards on page load
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => {
        // Add a small delay to ensure Kimonix content is loaded
        setTimeout(processKimonixCards, 500);
      });
    } else {
      // Add a small delay to ensure Kimonix content is loaded
      setTimeout(processKimonixCards, 500);
    }

    // Watch for new Kimonix cards being added dynamically
    const observer = new MutationObserver((mutations) => {
      let shouldProcess = false;
      mutations.forEach(mutation => {
        mutation.addedNodes.forEach(node => {
          if (node.nodeType === 1) { // Element node
            if (node.id === 'kmnx-open-prd' || (node.querySelector && node.querySelector('a[id="kmnx-open-prd"]'))) {
              shouldProcess = true;
            }
          }
        });
      });
      if (shouldProcess) {
        setTimeout(processKimonixCards, 200);
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }
})();

